import React from 'react'

const VerbatimSlide = () => (
    <div style={{ backgroundColor: '#102E4A', height: '100%' }}>
        <div style={{ height: 10, backgroundColor: '#0B243A', position: 'relative' }}>
            <img src="https://cdn.explori.com/images/logo_explori.png" alt="explori logo" style={{ height: 5, position: 'absolute', right: 2, top: 2 }} />
        </div>

        <div style={{ width: '100%', height: 'calc(100% - 12px)', padding: 5, display: 'flex', justifyContent: 'space-between' }}>
            {new Array(3).fill(0).map((_) => (
                <div style={{ height: '100%', width: '30%', backgroundColor: '#0B243A', display: 'flex', flexDirection: 'column', gap: 2, padding: 3 }}>
                    <div style={{ height: 1, width: '50%', backgroundColor: 'white' }} />

                    <div style={{ height: '100%', width: '100%', backgroundColor: '#102E4A'}}></div>

                    <div style={{ height: '100%', width: '100%', backgroundColor: '#102E4A'}}></div>

                    <div style={{ height: '100%', width: '100%', backgroundColor: '#102E4A'}}></div>
                </div>
            ))}
        </div>
    </div>
)

export default VerbatimSlide